<template>
    <v-card flat hover elevation="20">
        <v-card-title primary-title text-center>
            <h4>Восстановление доступа</h4>
        </v-card-title>
        <v-card-text>
            <v-form
                    ref="form"
                    v-model="valid"
                    v-if="messageSend === false"
            >
                <v-text-field
                        prepend-icon="email"
                        label="Электронная почта"
                        v-model="userModel.email"
                        required
                        autofocus
                        :rules="[rules.required, rules.email]"
                ></v-text-field>
            </v-form>
            <span v-if="messageSend === true">Через {{Math.floor(seconds/100)}} {{secondsText}} вы будете переадресованы на главную страницу</span>
        </v-card-text>
        <v-card-actions>
            <v-row>
                <v-col cols="12" xs12 v-if="messageSend === false">
                    <v-card class="d-flex justify-center" flat>
                        <v-btn
                                :disabled="!valid"
                                color="primary"
                                block
                                @click="sendPasswordResetForm"
                                text
                        >
                            Отправить письмо для восстановления
                        </v-btn>
                    </v-card>
                </v-col>
                <v-col cols="12" xs12>
                    <v-card class="d-flex justify-center" flat v-if="false">
                        <v-btn
                                color="primary"
                                block
                                @click="messageSend = true"
                                text
                        >
                            Активировать messageSend
                        </v-btn>
                    </v-card>
                </v-col>
                <v-col cols="12" xs12 v-if="messageSend === true">
                    <v-progress-linear :height="10" :value="100 - Math.floor(seconds/10)"></v-progress-linear>
                </v-col>
                <v-col cols="12" xs12 v-if="messageSend === true">
                    <v-card class="d-flex justify-center" flat>
                        <v-btn
                                color="primary"
                                block
                                @click="$router.push('/')"
                                text
                        >
                            Перейти сейчас
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-actions>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from 'axios'
import constConf from '../../constconf'

export default {
    name: 'ChangePassword',
    data () {
        return {
            seconds: 1000,
            messageSend: false,
            valid: false,
            userModel: {
                email: ''
            },
            snackbar: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Пароль успешно отправлен'
            },
            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Неверный формат электронной почты.'
                }
            }
        }
    },
    methods: {
        sendPasswordResetForm() {
            axios.defaults.withCredentials = true
            axios.post(constConf.user.url + '/user/request-password-reset', this.userModel)
                .then(response => {
                    console.log(response.data)
                    if (!response.data.hasOwnProperty('error')) {
                        // this.setcookie('user', 'login', +this.userModel.rememberMe === 1 ? 10 : 0)
                        // this.$router.push('bot')
                        // this.$store.dispatch('user/loadUserByModel', response.data)
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = response.data.success.text
                        this.snackbar = true
                        this.messageSend = true
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = response.data.error.text
                        this.snackbar = true
                    }
                })
                .catch(function (error) {
                    console.error(error.response)
                })
        }
    },
    watch: {
        messageSend() {
            if (this.messageSend) {
                let seconds = setInterval(() => {
                    this.seconds = this.seconds - 1
                    if (this.seconds <= 0) {
                        clearInterval(seconds) // остановка функции
                        this.$router.push('login')
                    }
                }, 10)
            }
        }
    },
    computed: {
        secondsText() {
            return Math.floor(this.seconds / 100) === 1 ? 'секунду' : Math.floor(this.seconds / 100) === 2 || Math.floor(this.seconds / 100) === 3 ? 'секудны' : 'секунд'
        }
    }
}
</script>

<style scoped>

</style>
